<template>
  <!-- 组件 -->
  <div class="programme">
    <div class="company_title" @click="selTabber(2)">
      解决方案
    </div>
    <div class="company_warn">
      致力于以数智技术为核心的建筑垃圾行业信息化和产业化经营方案的咨询、研发、实施、业务运营
    </div>  
    <div class="solution">
      <div class="each_solution"> 
        <img class="each_img" src="/static/img/index/solution01.png" alt="">
        <div class="each_title">行业监管</div>
        <div class="each_word">行业领先技术力量，保障城市级建筑垃圾项目开发成功落地</div>
        <div class="each_go" @click="goSolve(1)">了解详情 <img class="goto_arrow" src="/static/img/common/arrow.png" alt=""></div>
      </div>
      <div class="each_solution">
        <img class="each_img" src="/static/img/index/solution02.png" alt="">
        <div class="each_title">业务运营</div>
        <div class="each_word">设备数据云链接，为建筑垃圾行业全过程业务流转保驾护航</div>
        <div class="each_go" @click="goSolve(2)">了解详情 <img class="goto_arrow" src="/static/img/common/arrow.png" alt=""></div>
      </div>
      <div class="each_solution">
        <img class="each_img" src="/static/img/index/solution03.png" alt="">
        <div class="each_title">数字平台</div>
        <div class="each_word">依托行业生态产业链，搭建全链路、智能化、可扩展的运营服务体系 </div>
        <div class="each_go" @click="goSolve(3)">了解详情 <img class="goto_arrow" src="/static/img/common/arrow.png" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  Watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {},
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    goSolve(e){
      this.$emit('goSolve',e)
    },
    selTabber(e){
      this.$emit('selTabber',e)
    }
  },
};
</script>


<style scoped lang="scss">
@import url(../home.css);
.programme{
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media screen and ( min-width: 1200px ) {
  .solution{
    width: 1200px;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .each_solution{
      width: 385px;
      height: 438px;
      background-color: #F8F9FD;
      display: flex;
      flex-direction: column;
      align-items: center;
      .each_img{
        width: 180px;
        margin-top: 30px;
      }
      .each_title{
        margin-top: 30px;
        font-weight: bold;
        font-size: 20px;
        letter-spacing: 0.02em;
        color: #262626;
      }
      .each_word{
        margin-top: 12px;
        width: 305px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.02em;
        color: #595959;
      }
      .each_go{
        margin-top: 60px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.02em;
        color: #0EA049;
        display: flex;
        align-items: center;
        cursor: pointer;
        .goto_arrow{
          width: 16px;
          margin-left: 5px;
        }
      }
    }
  }
}
@media screen and ( min-width: 1000px ) and ( max-width: 1200px ) {
  .solution{
    width: 75rem;
    margin-top: 1.875rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .each_solution{
      width: 24.0625rem;
      height: 27.375rem;
      background-color: #F8F9FD;
      display: flex;
      flex-direction: column;
      align-items: center;
      .each_img{
        width: 11.25rem;
        margin-top: 1.875rem;
      }
      .each_title{
        margin-top: 1.875rem;
        font-weight: bold;
        font-size: 1.25rem;
        letter-spacing: 0.02em;
        color: #262626;
      }
      .each_word{
        margin-top: .75rem;
        width: 19.0625rem;
        font-weight: 400;
        font-size: .875rem;
        line-height: 1.25rem;
        text-align: center;
        letter-spacing: 0.02em;
        color: #595959;
      }
      .each_go{
        margin-top: 3.75rem;
        font-weight: 400;
        font-size: .875rem;
        line-height: 1.25rem;
        letter-spacing: 0.02em;
        color: #0EA049;
        display: flex;
        align-items: center;
        cursor: pointer;
        .goto_arrow{
          width: 1rem;
          margin-left: .3125rem;
        }
      }
    }
  }
}
@media screen and ( max-width: 1000px ) {
  .solution{
    width: 23.4375rem;
    margin-top: .625rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    box-sizing: border-box;
    .each_solution{
      width: 6.9375rem;
      height: 10rem;
      background-color: #F8F9FD;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .each_img{
        height: 4.25rem;
      }
      .each_title{
        margin-top: .6875rem;
        font-weight: bold;
        font-size: .875rem;
        letter-spacing: 0.02em;
        color: #262626;
      }
      .each_word{
        display: none;
      }
      .each_go{
        margin-top: .25rem;
        font-weight: 400;
        font-size: .75rem;
        letter-spacing: 0.02em;
        color: #0EA049;
        .goto_arrow{
          width: .625rem;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/index/components/home-programme.vue